import React from "react";
import { getHospitalLogoClassName, getHospitalLogoSrc, TELECARE_LOGO_SRC } from "../../utils/hospitalLogo";

const PublicSecureFileBrandHeader = ({
  eyebrow = "Secure Document Portal",
  title = "Secure File Access",
  subtitle = "Password-protected document sharing",
}) => (
  <header className="public-secure-file-brand">
    <div className="public-secure-file-brand-logos">
      <img
        src={getHospitalLogoSrc()}
        alt="Hospital logo"
        className={`public-secure-file-logo-hospital ${getHospitalLogoClassName("logo-large")}`}
      />
      <div className="public-secure-file-provided-by">
        <span className="public-secure-file-provided-by-label">Provided by</span>
        <img src={TELECARE_LOGO_SRC} alt="Telecare" className="public-secure-file-logo-telecare" />
      </div>
    </div>
    <div className="public-secure-file-brand-copy">
      <p className="public-secure-file-eyebrow">{eyebrow}</p>
      <h1 className="public-secure-file-title">{title}</h1>
      <p className="public-secure-file-subtitle">{subtitle}</p>
    </div>
  </header>
);

export default PublicSecureFileBrandHeader;
